module.exports = __webpack_public_path__ + "static/bnr_square@2x-cd7795866932bc570471ed4d5a7b8c09.webp";